import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa6";
import { Menu, MenuButton, MenuItem } from "../components/core/basic/Menu";
import { useUpdateLanguagePreference } from "../modules/settings/api/useUpdateLanguagePreference";
import { LANGUAGE_DISPLAY_NAMES, SUPPORTED_LANGUAGES, type SupportedLanguage } from "./languages";

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation("common");
  const updateLanguagePreference = useUpdateLanguagePreference();

  const current =
    (SUPPORTED_LANGUAGES as readonly string[]).includes(i18n.resolvedLanguage ?? "") ?
      (i18n.resolvedLanguage as SupportedLanguage)
    : "en";

  return (
    <MenuButton
      label={<FaGlobe />}
      buttonProps={{ variant: "icon", "aria-label": t(($) => $.common.language.Language) }}
    >
      <Menu
        selectionMode="single"
        selectedKeys={[current]}
        onAction={(key) => {
          const lng = String(key);
          void i18n.changeLanguage(lng);
          updateLanguagePreference.mutate(lng);
        }}
      >
        {SUPPORTED_LANGUAGES.map((code) => (
          <MenuItem key={code} id={code}>
            {LANGUAGE_DISPLAY_NAMES[code]}
          </MenuItem>
        ))}
      </Menu>
    </MenuButton>
  );
}
